export enum EnumSortOrder {
    DESC = 'desc',
    ASC = 'asc'
}

export enum EnumSortBy {
    DATE = 'release_date',
    VOTE = 'vote_average'
}

export enum EnumSearchBy {
    TITLE = 'title',
    GENRES = 'genres'
}
